import styled from 'styled-components'
import { Form as AntForm, Input, Button, message, Select } from 'antd'
import { useMutation, useQuery } from '@apollo/client'
import { useParams, useNavigate } from 'react-router-dom'

import {
    Top
} from '../../components'
import { UPDATE_ONE_ADMIN, FIND_UNIQUE_ADMIN } from '../../gqls'
import { ROLES_TO_SHARE } from '../../utils/const'

const Form = styled(AntForm)`
    max-width: 600px;
`
const rules = {
    required: {
        required: true,
        message: 'Обязательное поле'
    }
}

const EditAdmin = () => {

    const [form] = Form.useForm()
    const { id } = useParams()
    const navigate = useNavigate()

    useQuery(FIND_UNIQUE_ADMIN, {
        variables: {
            where: { id }
        },
        onCompleted: ({ findUniqueAdmin }) => {
            form.setFieldsValue({
                ...findUniqueAdmin
            })
        }
    })

    const [updateAdmin, { loading }] = useMutation(UPDATE_ONE_ADMIN, {
        onCompleted: () => {
            navigate("/admin")
            message.success("Администратор изменен")
        }
    })

    const handleSubmit = ({ name, email, type }) => {
        updateAdmin({
            variables: {
                where: { id },
                data: {
                    name: { set: name },
                    email: { set: email },
                    type: { set: type }
                }
            }
        })
    }

    return (
        <>
            <Top title={"Редактирование администратора"} />
            <Form form={form} onFinish={handleSubmit} layout="vertical">
                <Form.Item
                    name={"name"}
                    rules={[rules.required]}
                    label="ФИО"
                >
                    <Input placeholder='Введите фио' />
                </Form.Item>
                <Form.Item
                    name={"email"}
                    rules={[rules.required]}
                    label="Адрес электронной почты"
                >
                    <Input placeholder='Введите Email' />
                </Form.Item>
                <Form.Item
                    name={"type"}
                    rules={[rules.required]}
                    label="Тип"
                >
                    <Select
                        placeholder="Выберите тип пользователя"
                        allowClear
                    >
                        {
                            Object.keys(ROLES_TO_SHARE).map(key => (
                                <Select.Option
                                    key={key}
                                >
                                    {ROLES_TO_SHARE[key]}
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Button loading={loading} type="primary" htmlType="submit">
                    Сохранить
                </Button>
            </Form>
        </>
    )
}

export default EditAdmin